// import { formulas } from '@/components/SettingsTeach/fields/NumbersField';

import CAR_ICON from '@/assets/img/icons/Car.png';
import PLANE_ICON from '@/assets/img/icons/Plane.png';
import ELEPHANT_ICON from '@/assets/img/icons/Elephant.png';
import HELICOPTER_ICON from '@/assets/img/icons/Helicopter.png';
import TIGER_ICON from '@/assets/img/icons/Tiger.png';
import FOX_ICON from '@/assets/img/icons/Fox.png';
import FAWN_ICON from '@/assets/img/icons/Fawn.png';
import CROCODILE_ICON from '@/assets/img/icons/Crocodile.png';
import SQUIRREL_ICON from '@/assets/img/icons/Squirrel.png';
import BEAR_ICON from '@/assets/img/icons/Bear.png';
import WOLF_ICON from '@/assets/img/icons/Wolf.png';
import LEOPARD_ICON from '@/assets/img/icons/Leopard.png';

export const host = process.env.BACKEND_URL;

export const SIGN_ADD = 0;
export const SIGN_SUB = 1;
export const SIGN_MIX = 2;

export const ROOM_TYPES_LEGACY = {
  ANZAN: 'roomA',
  COLUMN: 'roomB',
  CARDS: 'roomC',
  SCHULTE: 'roomD',
};

export const ROOM_TYPES = {
  ANZAN: 'anzan',
  COLUMN: 'columns',
  CARDS: 'cards',
  SCHULTE: 'schulte',
};

export const ROOMS = [
  {
    type: ROOM_TYPES.ANZAN,
    title: 'roomA',
  },
  {
    type: ROOM_TYPES.COLUMN,
    title: 'roomB',
  },
  {
    type: ROOM_TYPES.CARDS,
    title: 'roomC',
  },
  {
    type: ROOM_TYPES.SCHULTE,
    title: 'roomD',
  },
];

export const NOT_EXCEED_50 = 0;
export const NOT_EXCEED_100 = 1;
export const EXCEED_100 = 2;

export const BOUNDS = {
  [NOT_EXCEED_50]: 'без перехода',
  [NOT_EXCEED_100]: 'за 50',
  [EXCEED_100]: 'за 100',
};

export const SIMULATOR_ICONS = [
  '',
  CAR_ICON,
  PLANE_ICON,
  ELEPHANT_ICON,
  HELICOPTER_ICON,
  TIGER_ICON,
  FOX_ICON,
  FAWN_ICON,
  CROCODILE_ICON,
  SQUIRREL_ICON,
  BEAR_ICON,
  WOLF_ICON,
  LEOPARD_ICON,
];

export const ICON_TITLES = [
  '',
  'CAR_ICON',
  'PLANE_ICON',
  'ELEPHANT_ICON',
  'HELICOPTER_ICON',
  'TIGER_ICON',
  'FOX_ICON',
  'FAWN_ICON',
  'CROCODILE_ICON',
  'SQUIRREL_ICON',
  'BEAR_ICON',
  'WOLF_ICON',
  'LEOPARD_ICON',
];

export const NO_MODE = 0;
export const RULE_SIMPLE_SUM = 1;
export const RULE_FIVE_SUM = 2;
export const RULE_TEN_SUM = 3;
export const RULE_FIVE_AND_TEN_SUM = 4;
export const MULTIPLICATION = 5;
export const DIVISION = 6;
export const SQRT = 7;
export const CURT = 8;
export const SQUARE = 9;
export const CUBE = 10;
export const DECIMAL_MODE = 11;

export const MODE_LIST = {
  [NO_MODE]: 'NO_MODE',
  [RULE_SIMPLE_SUM]: 'RULE_SIMPLE_SUM',
  [RULE_FIVE_SUM]: 'RULE_FIVE_SUM',
  [RULE_TEN_SUM]: 'RULE_TEN_SUM',
  [RULE_FIVE_AND_TEN_SUM]: 'RULE_FIVE_AND_TEN_SUM',
  [MULTIPLICATION]: 'MULTIPLICATION',
  [DIVISION]: 'DIVISION',
  [SQRT]: 'SQRT',
  [CURT]: 'CURT',
  [SQUARE]: 'SQUARE',
  [CUBE]: 'CUBE',
  [DECIMAL_MODE]: 'DECIMAL_MODE',
};

export const SECTION_TEN = 1;
export const SECTION_MIRROR = 2;
export const SECTION_UP_TO_FOUR = 4;
export const SECTION_UP_TO_FIVE = 5;
export const SECTION_UP_TO_SIX = 6;
export const SECTION_UP_TO_SEVEN = 7;
export const SECTION_UP_TO_EIGHT = 8;
export const SECTION_UP_TO_NINE = 9;

export const SIMPLE_LIST = {
  [SECTION_TEN]: 'SECTION_TEN',
  [SECTION_MIRROR]: 'SECTION_MIRROR',
  [SECTION_UP_TO_FOUR]: 'SECTION_UP_TO_FOUR',
  [SECTION_UP_TO_FIVE]: 'SECTION_UP_TO_FIVE',
  [SECTION_UP_TO_SIX]: 'SECTION_UP_TO_SIX',
  [SECTION_UP_TO_SEVEN]: 'SECTION_UP_TO_SEVEN',
  [SECTION_UP_TO_EIGHT]: 'SECTION_UP_TO_EIGHT',
  [SECTION_UP_TO_NINE]: 'SECTION_UP_TO_NINE',
};

export const SECTION_MULTIPLICATION_TABLE = 1;
export const SECTION_MULTIPLICATION_SIMPLE = 2;
export const SECTION_MULTIPLICATION_RANDOM = 3;
export const SECTION_MULTIPLICATION_ONE_ITERATE = 4;
export const SECTION_MULTIPLICATION_MORE_ITERATE = 5;

export const MULTIPLICATION_LIST = {
  [SECTION_MULTIPLICATION_TABLE]: 'MULTIPLICATION_TABLE',
  [SECTION_MULTIPLICATION_SIMPLE]: 'MULTIPLICATION_SIMPLE',
  [SECTION_MULTIPLICATION_RANDOM]: 'MULTIPLICATION_RANDOM',
  [SECTION_MULTIPLICATION_ONE_ITERATE]: 'MULTIPLICATION_ONE_ITERATE',
  [SECTION_MULTIPLICATION_MORE_ITERATE]: 'MULTIPLICATION_MORE_ITERATE',
};

export const SECTION_DIVISION_TABLE = 1;
export const SECTION_DIVISION_REMAINDER = 2;
export const SECTION_DIVISION_SIMPLE = 3;
export const SECTION_DIVISION_ONE_ITERATE = 4;
export const SECTION_DIVISION_MORE_ITERATE = 5;
export const SECTION_DIVISION_SAME = 6;
export const SECTION_DIVISION_BY_ONE = 7;
export const SECTION_DIVISION_RANDOM = 8;

export const DIVISION_LIST = {
  [SECTION_DIVISION_TABLE]: 'DIVISION_TABLE',
  [SECTION_DIVISION_REMAINDER]: 'DIVISION_REMAINDER',
  [SECTION_DIVISION_SIMPLE]: 'DIVISION_SIMPLE',
  [SECTION_DIVISION_ONE_ITERATE]: 'DIVISION_ONE_ITERATE',
  [SECTION_DIVISION_MORE_ITERATE]: 'DIVISION_MORE_ITERATE',
  [SECTION_DIVISION_SAME]: 'DIVISION_SAME',
  [SECTION_DIVISION_BY_ONE]: 'DIVISION_BY_ONE',
  [SECTION_DIVISION_RANDOM]: 'DIVISION_RANDOM',
};

export const ANSWER_DISCHARGE_TYPES = {
  DIGITS_MODE_RANDOM_RANGE: 'random',
  DIGITS_MODE_MIN_RANGE: 'min',
  DIGITS_MODE_MAX_RANGE: 'max',
};

export const RANDOM_ROTATION = 0;
export const SINGLE_ROTATION = 1;
export const DOUBLE_ROTATION = 2;

const columns = ['a', 'b', 'c', 'd', 'e', 'f'];

export const DIGITS_MODE_MIN_RANGE = 1;
export const DIGITS_MODE_MAX_RANGE = 2;

export const digitsNumbers = [
  { value: 1, label: 1 },
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 },
];

export const leftNumbers = [
  { value: 1, label: 1 },
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
];
export const rightNumbers = [
  { value: 6, label: 6 },
  { value: 7, label: 7 },
  { value: 8, label: 8 },
  { value: 9, label: 9 },
];
export const numbers = [
  ...leftNumbers,
  { value: 5, label: 5 },
  ...rightNumbers,
];

export const abacusInitState = {
  a: [0, 0, 0, 0, 0],
  b: [0, 0, 0, 0, 0],
  c: [0, 0, 0, 0, 0],
  d: [0, 0, 0, 0, 0],
  e: [0, 0, 0, 0, 0],
};

export const labels = {
  roomA: 'Анзан',
  roomB: 'Столбики',
  roomC: 'Флэш-карты',
  roomD: 'Таблица Шульте',
};

export const SECTION = {
  [SECTION_UP_TO_FOUR]: 'Счет до 4',
  [SECTION_UP_TO_FIVE]: 'Счет до 5',
  [SECTION_UP_TO_SIX]: 'Счет до 6',
  [SECTION_UP_TO_SEVEN]: 'Счет до 7',
  [SECTION_UP_TO_EIGHT]: 'Счет до 8',
  [SECTION_UP_TO_NINE]: 'Счет до 9',
  [SECTION_MIRROR]: 'Зеркальные',
  [SECTION_TEN]: 'Круглые числа',
};

export const INTERVALS = [];

for (let i = 0.1; i.toFixed(1) <= 10; i += 0.1) {
  INTERVALS.push(Number(i.toFixed(1)));
}

export const steps = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 15, 18, 20, 25, 30];
// для формул в ANZAN оставляем 30, иначе генератор висит
export const stepsAnzan = [
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  12,
  15,
  18,
  20,
  25,
  30,
  35,
  40,
  45,
  50,
  55,
  60,
  65,
  70,
  75,
  80,
  85,
  90,
  95,
  100,
];

// разряды для десятичных и для других тем (under,over)
export const UNDER_OPTIONS_DEFAULT = [
  { value: 1, label: 1 },
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 },
];
export const UNDER_OPTIONS_DECIMAL = [
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 },
  { value: 6, label: 6 },
  { value: 7, label: 7 },
  { value: 8, label: 8 },
];
export const OVER_OPTIONS_DEFAULT = UNDER_OPTIONS_DEFAULT;
export const OVER_OPTIONS_DECIMAL = UNDER_OPTIONS_DECIMAL;

export const colors = [
  '#CCCC00',
  '#FFCC66',
  '#FFCC00',
  '#FFCC33',
  '#CC9900',
  '#CC9933',
  '#996600',
  'FF9900',
  '#FF9933',
  '#CC9966',
  '#CC6600',
  '#996633',
  '#663300',
  '#FFCC99',
  '#FF9966',
  '#FF6600',
  '#CC6633',
  '#993300',
  '#660000',
  '#FF6633',
  '#CC3300',
  '#FF3300',
  '#FF0000',
  '#CC0000',
  '#990000',
  '#FFCCCC',
  '#FF9999',
  '#FF6666',
  '#FF3333',
  '#FF0033',
  '#CC0033',
  '#CC9999',
  '#CC6666',
  '#CC3333',
  '#993333',
  '#990033',
  '#330000',
  '#FF6699',
  '#FF3366',
  '#FF0066',
  '#CC3366',
  '#996666',
  '#663333',
  '#FF99CC',
  '#FF3399',
  '#FF0099',
  '#CC0066',
  '#993366',
  '#660033',
  '#FF66CC',
  '#FF00CC',
  '#FF33CC',
  '#CC6699',
  '#CC0099',
  '#990066',
  '#FFCCFF',
  '#FF99FF',
  '#FF66FF',
  '#FF33FF',
  '#FF00FF',
  '#CC3399',
  '#CC99CC',
  '#CC66CC',
  '#CC00CC',
  '#CC33CC',
  '#990099',
  '#993399',
  '#CC66FF',
  '#CC33FF',
  '#CC00FF',
  '#9900CC',
  '#996699',
  '#660066',
  '#CC99FF',
  '#9933CC',
  '#9933FF',
  '#9900FF',
  '#660099',
  '#663366',
  '#9966CC',
  '#9966FF',
  '#6600CC',
  '#6633CC',
  '#663399',
  '#330033',
  '#CCCCFF',
  '#9999FF',
  '#6633FF',
  '#6600FF',
  '#330099',
  '#330066',
  '#9999CC',
  '#6666FF',
  '#6666CC',
  '#666699',
  '#333399',
  '#333366',
  '#3333FF',
  '#3300FF',
  '#3300CC',
  '#3333CC',
  '#000099',
  '#000066',
  '#6699FF',
  '#3366FF',
  '#0000FF',
  '#0000CC',
  '#0033CC',
  '#000033',
  '#0066FF',
  '#0066CC',
  '#3366CC',
  '#0033FF',
  '#003399',
  '#003366',
  '#99CCFF',
  '#3399FF',
  '#0099FF',
  '#6699CC',
  '#336699',
  '#006699',
  '#66CCFF',
  '#33CCFF',
  '#00CCFF',
  '#3399CC',
  '#0099CC',
  '#003333',
  '#99CCCC',
  '#66CCCC',
  '#339999',
  '#669999',
  '#006666',
  '#336666',
  '#CCFFFF',
  '#99FFFF',
  '#66FFFF',
  '#33FFFF',
  '#00FFFF',
  '#00CCCC',
  '#99FFCC',
  '#66FFCC',
  '#33FFCC',
  '#00FFCC',
  '#33CCCC',
  '#009999',
  '#66CC99',
  '#33CC99',
  '#00CC99',
  '#339966',
  '#009966',
  '#006633',
  '#66FF99',
  '#33FF99',
  '#00FF99',
  '#33CC66',
  '#00CC66',
  '#009933',
  '#99FF99',
  '#66FF66',
  '#33FF66',
  '#00FF66',
  '#339933',
  '#006600',
  '#CCFFCC',
  '#99CC99',
  '#66CC66',
  '#669966',
  '#336633',
  '#003300',
  '#33FF33',
  '#00FF33',
  '#00FF00',
  '#00CC00',
  '#33CC33',
  '#00CC33',
  '#66FF00',
  '#66FF33',
  '#33FF00',
  '#33CC00',
  '#339900',
  '#009900',
  '#CCFF99',
  '#99FF66',
  '#66CC00',
  '#66CC33',
  '#669933',
  '#336600',
  '#99FF00',
  '#99FF33',
  '#99CC66',
  '#99CC00',
  '#99CC33',
  '#669900',
  '#CCFF66',
  '#CCFF00',
  '#CCFF33',
  '#CCCC99',
  '#666633',
  '#333300',
  '#CCCC66',
  '#CCCC33',
  '#999966',
  '#999933',
  '#999900',
  '#CCCCCC',
  '#999999',
  '#333333',
];

export const sumOnRod = rod =>
  rod.reduce((accumulator, value, index) => {
    let summand = 0;
    if (value === 1) {
      summand = index === 0 ? 5 : 1;
    }
    return accumulator + summand;
  }, 0);

export const sumAbacus = abacusState =>
  Object.values(abacusState)
    .reverse()
    .reduce((accumulator, value, index) => {
      const summand = sumOnRod(value);
      const order = Number('1'.padEnd(index + 1, '0'));
      return accumulator + summand * order;
    }, 0);

const entity = 'SIMULATORS';

export const types = {
  SET_PARAMS: `${entity}/SET_PARAMS`,
  SET_CONTROLS: `${entity}/SET_CONTROLS`,
  SET_DICTATION: `${entity}/SET_DICTATION`,
  SET_POSITION: `${entity}/SET_POSITION`,
  SET_SHOW_TRAINER: `${entity}/SET_SHOW_TRAINER`,
  SET_CURRENT_ROOM: `${entity}/SET_CURRENT_ROOM`,
  ON_START: `${entity}/ON_START`,
  CHANGE_PARAMS: `CHANGE_PARAMS`,
  CHANGE_PARAMS_ALL: `${entity}/CHANGE_PARAMS_ALL`,
  CHANGE_CONTROLS_ALL: `${entity}/CHANGE_CONTROLS_ALL`,
  CHANGE_DICTATION_ALL: `${entity}/CHANGE_DICTATION_ALL`,
  // SET_COMMON_START: `${entity}/SET_COMMON_START`,
  // SET_DICTATION_START: `${entity}/SET_DICTATION_START`,
  // SET_DICTATION_STOP: `${entity}/SET_DICTATION_STOP`,
  // SET_DICTATION_PROGRESS: `${entity}/SET_DICTATION_PROGRESS`,
  // SET_COMMON_CONTROLS: `${entity}/SET_COMMON_CONTROLS`,
  // SET_COMMON_AMOUNT: `${entity}/SET_COMMON_AMOUNT`,
  // SET_COMMON_PARAMS: `${entity}/SET_COMMON_PARAMS`,
  // SET_COMMON_STOP: `${entity}/SET_COMMON_STOP`,
  // SET_COMMON_CHECK: `${entity}/SET_COMMON_CHECK`,
  // SET_COMMON_SHOW_ANSWER: `${entity}/SET_COMMON_SHOW_ANSWER`,
  // SET_COMMON_DICTATION: `${entity}/SET_COMMON_DICTATION`,
};

export const UPDATE_PROPERTY = 'UPDATE_PROPERTY';
export const UPDATE_PROPERTY_FILTER = 'UPDATE_PROPERTY_FILTER';
export const UPDATE_PROPERTY_CONTROLS = 'UPDATE_PROPERTY_CONTROLS';
export const UPDATE_ALL_PROPERTY_FILTER = 'UPDATE_ALL_PROPERTY_FILTER';
export const SHOW_ABACUS = 'SHOW_ABACUS';
export const HIDE_ABACUS = 'HIDE_ABACUS';

/*
 * Определяет является ли пользователь получателем сообщения
 * @param {object} workareaUser - пользователь рабочей области
 * @param {object} sender - отправитель сообщения
 * @param {object} receiver - то кому направляется сообщение,
 * тот кто указан в поле to сообщения
 */
export const isReceiver = (workareaUser, sender, receiver) => {
  if (!receiver) return false;

  if (receiver.type === 'teacher') {
    return true;
  }

  if (['student', 'learner'].includes(receiver.type)) {
    if (
      sender.id === workareaUser.id &&
      ['student', 'learner'].includes(workareaUser.type)
    ) {
      return true;
    }

    if (sender.type === 'teacher' && receiver.id === workareaUser.id) {
      return true;
    }
  }

  return false;
};

/*
 * Ищет сравнение отправить = получатель
 * !!!!!!!!! Для unikum-kids изменена логика работы
 * @param {object} workareaUser - пользователь рабочей области
 * @param {object} sender - отправитель сообщения
 * @param {object} receiver - то кому направляется сообщение,
 * тот кто указан в поле to сообщения
 */
// export const isReceiver = (workareaUser, sender, receiver) =>
//   receiver &&
//   (sender.id === workareaUser.id ||
//     (sender.type === 'teacher' && receiver.id === workareaUser.id));

/**
 * Заполняет состояние абака единицами согласно
 * переданному числу
 * @param {number} number - число которое нужно набрать на абаке
 * @param {number} range - это порядок абака
 * @return {object} состояние абакуса
 */
export const fillingValues = (number, range) => {
  let nextAbacus = {};

  for (let i = 0; i < range; i += 1) {
    nextAbacus = { ...nextAbacus, [columns[i]]: [0, 0, 0, 0, 0] };
  }

  if (number) {
    let k = range;
    let pod = [0, 0, 0, 0, 0];
    const numberComposition = number.toString();

    const podMap = {
      '1': [0, 1, 0, 0, 0],
      '2': [0, 1, 1, 0, 0],
      '3': [0, 1, 1, 1, 0],
      '4': [0, 1, 1, 1, 1],
      '5': [1, 0, 0, 0, 0],
      '6': [1, 1, 0, 0, 0],
      '7': [1, 1, 1, 0, 0],
      '8': [1, 1, 1, 1, 0],
      '9': [1, 1, 1, 1, 1],
    };

    for (let i = numberComposition.length - 1; i >= 0; i -= 1) {
      k -= 1;
      pod = podMap[numberComposition[i]] || [0, 0, 0, 0, 0];
      nextAbacus = { ...nextAbacus, [columns[k]]: pod };
    }
  }

  return nextAbacus;
};

// Reducer
const initialState = {
  params: [
    {
      mode: RULE_SIMPLE_SUM,
      section: SECTION_UP_TO_NINE,
      numbers: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
      animation: 9,
      interval: 1,
      sign: 0,
      steps: 3,
      under: 1,
      over: 1,
      bound: 0,
      icon: 0,
      base: 10,
      base_side: 1,
      digits_mode: 1,
      first_int_available_numbers: 1,
      second_int_available_numbers: 1,
      answer_discharge_type: 'random',
      rotation_type: 0,
    },
  ],
  controls: {
    count: 5,
    start: false,
    stop: false,
    check: false,
    clear: false,
    abacus: false,
    settings: true,
    repeat: false,
    correct: false,
    open: false,
    sound: false,
    sample: false,
    showAnswers: false,
  },
  dictationState: {
    dictation: false,
    amount: 3,
    start: false,
    progress: false,
    stop: false,
    period: 5,
    samples: [],
  },
  visible: {
    answerCounter: {
      sound: true,
      settings: true,
      sample: true,
      play: true,
      params: true,
      abacus: true,
      showAnswers: true,
    },
  },
  currentRoom: {},
  showTrainer: true,
  displayAbacus: false,
  windows: 6,
  open: true,
  room: 'roomB',
};

const simulatorsrReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ON_START: {
      return {
        ...state,
        controls: { ...state.controls, start: true, stop: false, check: false },
      };
    }
    case types.SET_PARAMS:
    case types.SET_DICTATION:
    case types.SET_SHOW_TRAINER:
    case types.SET_CONTROLS:
    case types.SET_WINDOWS:
    case types.SET_POSITION: {
      return {
        ...state,
        [action.meta]: action.payload,
      };
    }

    case types.SET_CURRENT_ROOM: {
      return {
        ...state,
        [action.meta]: action.payload,
        room: action.payload.name,
      };
    }

    case UPDATE_PROPERTY_FILTER: {
      return {
        ...state,
        params: { ...state.params, [action.payload.prop]: action.payload.data },
      };
    }
    case UPDATE_PROPERTY_CONTROLS: {
      return {
        ...state,
        controls: action.payload.controls,
      };
    }
    case UPDATE_PROPERTY: {
      return { ...state, [action.payload.prop]: action.payload.data };
    }
    case UPDATE_ALL_PROPERTY_FILTER: {
      return { ...state, params: action.payload.data };
    }
    case SHOW_ABACUS: {
      return { ...state, displayAbacus: true };
    }
    case HIDE_ABACUS: {
      return { ...state, displayAbacus: false };
    }

    default:
      return state;
  }
};

// Actions

/**
 * Обновляем свойства первого уровня
 * @param {string} prop - наименование свойства.
 * @param {object} data - значение.
 * @returns {object}.
 */
export function updateProp(prop, data) {
  return dispatch => {
    dispatch({
      type: UPDATE_PROPERTY,
      payload: {
        prop,
        data,
      },
    });
  };
}

/**
 * Обновляем свойства первого уровня
 * @param {string} prop - наименование свойства.
 * @param {object} data - значение.
 * @returns {object}.
 */
function updatePropFilter(prop, data) {
  return dispatch => {
    dispatch({
      type: UPDATE_PROPERTY_FILTER,
      payload: {
        prop,
        data,
      },
    });
  };
}

const updatePropControl = controls => dispatch =>
  dispatch({
    type: UPDATE_PROPERTY_CONTROLS,
    payload: { controls },
  });

/**
 * Обновляем свойства фильтра  оюъект переменной params
 * @param {object} data - значение.
 * @returns {object}.
 */
export function updateAllPropFilter(data) {
  return dispatch => {
    dispatch({
      type: UPDATE_ALL_PROPERTY_FILTER,
      payload: {
        data,
      },
    });
  };
}

/**
 * Показываем абак
 * @returns {object}.
 */
export function showAbacus() {
  return dispatch => {
    dispatch({
      type: SHOW_ABACUS,
    });
  };
}

/**
 * Скрываем абак
 * @returns {object}.
 */
export function hideAbacus() {
  return dispatch => {
    dispatch({
      type: HIDE_ABACUS,
    });
  };
}

function setShowTrainer(payload) {
  return dispatch => {
    dispatch({
      type: types.SET_SHOW_TRAINER,
      meta: 'showTrainer',
      payload,
    });
  };
}

function setCurrentRoom(payload) {
  return dispatch => {
    dispatch({
      type: types.SET_CURRENT_ROOM,
      meta: 'currentRoom',
      payload,
    });
  };
}

function setParams(payload) {
  return dispatch => {
    dispatch({
      type: types.SET_PARAMS,
      meta: 'params',
      payload,
    });
  };
}

function setControls(payload) {
  return dispatch => {
    dispatch({
      type: types.SET_CONTROLS,
      meta: 'controls',
      payload,
    });
  };
}

function setDictation(payload) {
  return dispatch => {
    dispatch({
      type: types.SET_DICTATION,
      meta: 'dictationState',
      payload,
    });
  };
}

function onStart() {
  return dispatch => {
    dispatch({
      type: types.ON_START,
    });
  };
}

export const actions = {
  setShowTrainer,
  updatePropFilter,
  updatePropControl,
  setCurrentRoom,
  setParams,
  setControls,
  setDictation,
  onStart,
  updateProp,
};

export default simulatorsrReducer;
